export const SET_ROLES = "SET_ROLES";
export const SET_ROLES_OPTIONS = "SET_ROLES_OPTIONS";
export const GET_ROLES = "GET_ROLES";
export const REFRESH_ROLES = "REFRESH_ROLES";